import { useCompanyNoteModal } from '@/components/Note';
import { useTranslation } from '@/hooks/useTranslation';
import NoteIcon from '@simplywallst/ui-core/icons/EditSolid';
import { useTracking } from 'react-tracking';
import type { Action } from '../types';

export const useNoteAction = (): Action => {
  const { openNoteModal, modalState } = useCompanyNoteModal();
  const t = useTranslation();
  const { trackEvent } = useTracking();

  const handleClick = ({
    companyId,
    uniqueSymbol,
  }: {
    companyId: string;
    uniqueSymbol: string;
  }) => {
    trackEvent({
      type: 'track',
      subject: 'addNote',
      action: 'click',
    });
    return openNoteModal({ companyId, uniqueSymbol });
  };

  return {
    key: 'note',
    cyId: 'header-add-note-button',
    isDisabled: modalState !== 'idle',
    smallProps: {
      label: t('page.companyReport.header.actions.addNote'),
      icon: <NoteIcon />,
    },
    handleClick,
  };
};
